import { ECustomerInfo } from "./LanguagePack/translatedFields";
import { Stack } from "@mui/material";
import { ContractField } from "./common";

export default function ContractCustomerInformation({
  selectedLanguage,
  reservation,
}) {
  if (!reservation) {
    return null;
  }

  const {
    //@ts-ignore
    name,
    //@ts-ignore
    ssn,
    //@ts-ignore
    address,
    //@ts-ignore
    postalCode,
    //@ts-ignore
    city,
    //@ts-ignore
    phone,
    //@ts-ignore
    email,
    //@ts-ignore
    customerNotes,
    //@ts-ignore
    billingRef,
  } = reservation;
  const fields = ECustomerInfo[selectedLanguage];

  const maskedSsn = ssn
    ? ssn.slice(0, -4) + ssn.slice(-4).replace(/./g, "*")
    : "";
  const hasRequiredLicense = reservation?.reservationVehicles?.some(
    (vehicle) =>
      vehicle?.additionalFields?.find(
        (field) => field?.key === "requiredLicense"
      )?.value
  );

  const clientName = getClientName(name, reservation);
  return (
    <Stack
      sx={{
        border: "1px solid lightgrey",
        padding: "5px",
        borderRadius: "5px",
      }}
      flex={1}
    >
      <Stack flex={1} direction={"column"} spacing={1}>
        <ContractField
          value={clientName}
          label={fields.NAME}
          visibility={true}
          sx={{ flex: 0.7 }}
        />
        <Stack direction={"row"} flex={0.3}>
          <ContractField
            value={maskedSsn}
            label={fields.SSN}
            visibility={true}
            sx={{ flex: 0.6 }}
          />
          <ContractField
            value={phone}
            label={fields.PHONE}
            visibility={true}
            sx={{ flex: 0.5 }}
          />{" "}
          {hasRequiredLicense && (
            <RequiredLicenseField reservation={reservation} fields={fields} />
          )}
        </Stack>
      </Stack>
      <ContractField
        value={
          address && postalCode && city
            ? `${address}, ${postalCode}, ${city}`
            : ""
        }
        label={fields.ADDRESS}
        visibility={true}
      />

      <ContractField value={email} label={fields.EMAIL} visibility={true} />
      {customerNotes && (
        <ContractField
          value={customerNotes}
          label={fields.CUSTOMER_NOTES}
          visibility={true}
        />
      )}
      {billingRef && (
        <ContractField
          value={billingRef}
          label={fields.BILLING_REFERENCE}
          visibility={true}
        />
      )}
    </Stack>
  );
}

const RequiredLicenseField = ({ reservation, fields }) => {
  const requiredLicenseValue = reservation?.reservationVehicles
    ?.flatMap((vehicle) => vehicle?.additionalFields || [])
    ?.find((field) => field?.key === "requiredLicense")?.value;

  return (
    <ContractField
      value={requiredLicenseValue}
      label={fields.DRIVERS_LICENSE_CLASS}
      visibility={true}
      sx={{ flex: 0.4 }}
    />
  );
};

const getClientName = (name, reservation) => {
  if (name) {
    return name;
  }
  return `${reservation?.firstName} ${reservation?.lastName}`;
};
